import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(res => {
        let data = res.data;

        // data.forEach(d => { d.metric1 = Math.log(d.metric1) });
        data.forEach(d => {
            d.dim1_name = d.dim1_name.replace(/[\W_]+/g, '')
            d.metric1 = +d.metric1
        });
        var svg = d3.select(divId).select("svg").remove();

        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");


        let y1tip = d3.select('body')
            .append("div")
            .attr("class", "tooltip")
            .style('line-height', '1')
            .style('padding', '12px')
            .style('background', 'white')
            .style('border-radius', '5px')
            .style('position', 'absolute')
            .style('border-width', '.1px')
            .style('border-style', 'groove')

        let svgBottom = svg.append("g").attr("class", "svgBottom");

        // let Domain = {
        //   full: "full",
        //   relative: "relative",
        // };
        //
        // let currentDomain = Domain.relative;
        let coordinates = d3.map(data, (d) => {
            return d.dim2_name
        }).keys()

        let color = d3.scaleOrdinal(fw_progressive_1way);

        let coordinatesScale = d3.scalePoint()
            .range([chart.margin.left, chart.width - chart.margin.right])
            .domain(coordinates)
            .padding(0.5);

        let coordinatesLines = svg.selectAll(".coordinatesLines")
            .data(coordinates)
            .enter()
            .append("line")
            .attr("y1", chart.margin.bottom - 6)
            .attr("y2", chart.height)
            .attr("x1", d => coordinatesScale(d))
            .attr("x2", d => coordinatesScale(d))
            .attr("stroke-width", 2.5)
            .attr("stroke", "lightgray");

        console.warn(coordinatesLines)

        let coordTitle = svg.selectAll(".coordTitle")
            .data(coordinates)
            .enter()
            .append("text");

        let totalLineData = [];

        // d3.selectAll(".button").on("click", function() {
        //       currentDomain = this.value
        //       coordinates.forEach(function(d,i) { drawCoordinates(d, i) });
        //       drawLines()
        // });

        coordinates.forEach(function (d, i) {
            drawCoordinates(d, i)
        });

        let selected = false;
        let selectedCountry, dimension1;

        let dropdown = d3.select("#drop");

        // dropdown.append("option")
        //   .property("selected", true)
        //   .text("Highlight a Category");

        dropdown.selectAll(".option")
            .data(data)
            .enter()
            .append("option")
        //  .attr("value",  function(d) { return d.dim1_name })
        //  .text( function(d) { return d.dim1_name });

        dropdown.on("change", function () {
            selected = true;
            dimension1 = this.value;
            selectedCountry = dimension1;
            // let currentColor = svg.select("circle").attr("fill");
            svg.selectAll("circle").attr("fill", function (d) {
                return color(d.dim1_name)
            });
            svg.selectAll("path").attr("stroke", "#bbb").attr("stroke-width", 2.5);
            d3.selectAll("circle." + dimension1).attr("fill", color(dimension1));
            d3.selectAll(".line" + dimension1).attr("stroke", color(dimension1)).attr("stroke-width", 2.5);
        });

        function drawCoordinates(dim2_name, index) {
            coordTitle.attr("text-anchor", "middle")
                .attr("class", "coordTitle")
                .attr("font-size", "16px")
                .attr("y", 46)
                .attr("x", (d, i) => coordinatesScale(coordinates[i]))
                .text(d => d)
                .append("tspan");

            let coordinatesDataset = [];

            for (const record of data) {
                if (record.dim2_name === dim2_name) {
                    coordinatesDataset.push(record);
                }
            }

            let verticalScale;
            // if (currentDomain === Domain.relative) {
            verticalScale = d3.scaleLinear()
                .range([chart.height - chart.margin.top, chart.margin.bottom])
                .domain([d3.min(coordinatesDataset, d => d.metric1),
                    d3.max(coordinatesDataset, d => d.metric1)]);
            // }
            // else {
            //     verticalScale = d3.scaleLinear()
            //         .range([chart.height - chart.margin.top, chart.margin.bottom])
            //         .domain([d3.min(data, d => d.metric1),
            //             d3.max(data, d => d.metric1)]);
            // }

            let simulation = d3.forceSimulation(coordinatesDataset)
                .force("x", d3.forceX(() => coordinatesScale(dim2_name)))
                .force("y", d3.forceY((d) => verticalScale(d.metric1)).strength(2))
                .force("collide", d3.forceCollide(6));

            for (let i = 0; i < coordinatesDataset.length * 2; ++i) {
                simulation.tick();
            }

            totalLineData.push(coordinatesDataset);

            let circles = svg.selectAll(`.circles${index}`)
                .data(coordinatesDataset, (d) => d.dim1_name);

            let circlesEnter = circles.enter().append("circle");

            circlesEnter.attr("r", 5)
                .attr("cx", coordinatesScale(coordinates[`${index}`]))
                .attr("cy", d => d.y + 10)
                .attr("fill", function (d) {
                    return color(d.dim1_name)
                })
                .attr("id", (d) => `${index}${d.dim1_name}`)
                .attr("class", d => `circles${index} ${d.dim1_name}`)
                .attr("id", (d) => `${index}${d.dim1_name}`);

            circles.transition()
                .duration(1500)
                .attr("r", 5)
                .attr("cx", coordinatesScale(coordinates[`${index}`]))
                .attr("cy", d => d.y + 10)
                .attr("fill", d => {
                    if (selected) {
                        if (d.dim1_name === selectedCountry) {
                            return color(d.dim1_name)
                        } else {
                            return color(d.dim1_name)
                        }
                    } else {
                        return color(d.dim1_name)
                    }
                });

            d3.selectAll(".circles" + index)
                .on("mousemove", function (d) {
                    selected = false;

                    y1tip.html(`
                              Category${colonAnnotation} <strong>${d.dim1_name}</strong><br>
                              Revenue by metric1${colonAnnotation} <strong>${numberFormat(d.metric1)}</strong>
                          `)
                        .style('top', d3.event.pageY - 12 + 'px')
                        .style('left', d3.event.pageX + 25 + 'px')
                        .style("opacity", 0.9);

                    svg.selectAll("circle").attr("fill", function (d) {
                        return color(d.dim1_name)
                    });
                    svg.selectAll("path").attr("stroke", "#bbb").attr("stroke-width", 2.5);
                    d3.selectAll("circle." + d.dim1_name).attr("fill", color(d.dim1_name));
                    d3.selectAll(".line" + d.dim1_name).attr("stroke", color(d.dim1_name)).attr("stroke-width", 2.5);
                })
                .on("mouseout", function (d) {
                    y1tip.style("opacity", 0);
                    d3.selectAll("circle." + d.dim1_name).attr("fill", color(d.dim1_name));
                    d3.selectAll(".line" + d.dim1_name).attr("stroke", "#bbb").attr("stroke-width", 2.5);
                });
        }

        drawLines();

        function drawLines() {
            let line = d3.line()
                .y(d => d.y + 10)
                .x((d, i) => coordinatesScale(coordinates[i]))
                .curve(d3.curveCatmullRom.alpha(1));

            data.forEach(d => {
                let dimension1 = d.dim1_name;

                let thisLineData = [];

                totalLineData.forEach(d => {
                    let filtered = d.filter(e => e.dim1_name === dimension1);
                    thisLineData.push({x: filtered[0].x, y: filtered[0].y})
                });

                if (!(d3.select(".line" + dimension1).nodes().length)) {
                    let linePath = svgBottom.append("path")
                        .datum(thisLineData)
                        .attr("class", () => {
                            return "line" + dimension1
                        })
                        .attr("d", line)
                        .attr("stroke-width", 2.5)
                        .attr("fill", "none")
                        .attr("stroke", "#bbb");

                    console.warn(linePath)
                } else if ((d3.select(".line" + dimension1).nodes().length)) {
                    d3.select(".line" + dimension1)
                        .datum(thisLineData)
                        .transition()
                        .duration(1500)
                        .attr("d", line);
                }
            });
            totalLineData = [];
        }

        var y1legend = svg.selectAll('.legend')
            .data(color.domain())
            .enter().append('g')
            .attr('class', 'legend')
            .attr("transform", function (d, i) {
                return "translate(30," + i * 25 + ")";
            });


        y1legend.append('rect')
            .attr('x', chart.width - 150)
            .attr('y', 75)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', color)

        y1legend.append('text')
            .attr("font-size", "12px")
            .attr('x', chart.width - 125)
            .attr('y', 85)
            .attr('dy', '.35em')
            .text(function (d) {
                return d
            })

    }).catch(function (error) {
        if (error) throw error;
    });
}
